import { Alert, Link } from '@customink/pigment-react';

export default function NoQuantitiesEntered({
  onEnterQuantitiesClick,
}: {
  onEnterQuantitiesClick?: () => void;
}) {
  return (
    <Alert severity="error">
      Please{' '}
      <Link
        button
        onClick={onEnterQuantitiesClick}
        sx={{ textDecoration: 'underline' }}
      >
        enter quantities
      </Link>{' '}
      to get your price.
    </Alert>
  );
}
